import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@wegroup/design-system';
import { setSubjects } from '../../store/redux/slices/selectionSlice';
import { SubjectTypes } from '../../../../../types/RiskAnalaysis';
import { subjectsByCountry } from '../../constants/subjects';
import SelectionViewWrapper from '../../components/selection/SelectionViewWrapper';
import SubjectSelectionCheckboxes from '../../components/selection/subject/SubjectSelectionCheckboxes';
import {
  useLouiseDispatch,
  useLouiseSelector,
} from '../../../../sales-conversation/src/store/redux/store';
import useStartRiskAnalysisFlow from '../../hooks/useStartRiskAnalysisFlow';
import useIsNLplan from '../../../../common/src/hooks/useIsNLPlan';

const SubjectSelection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useLouiseDispatch();
  const selectedValues = useLouiseSelector(
    (state) => state.riskAnalysisSelection.subjects,
  );

  const { t } = useTranslation();
  const { isNL } = useIsNLplan();
  const plan = isNL ? 'NL' : 'BE';

  // Init hooks
  const startRiskAnalysisFlow = useStartRiskAnalysisFlow();

  // Calling handle change once to filter out NL or BE subjects
  useEffect(() => {
    handleChange(selectedValues);
  }, []);

  const handleChange = (values: SubjectTypes[]) => {
    dispatch(
      setSubjects(
        values.filter((val) => subjectsByCountry[plan].includes(val)),
      ),
    );
  };

  const handleOnContinueClick = () => {
    startRiskAnalysisFlow();
  };

  return (
    <SelectionViewWrapper
      onBackUrl="/risk-analysis/selection/flow-selection"
      onContinueClick={handleOnContinueClick}
      question={t('For which topics would you like to conduct an analysis?')}
      disabled={selectedValues.length <= 0}
    >
      <Flex
        flexWrap="wrap"
        gridGap="6"
        justifyContent={{ base: 'flex', mobileL: 'center' }}
        mx="auto"
        maxW="3xl"
      >
        <SubjectSelectionCheckboxes
          subjects={subjectsByCountry[plan]}
          handleChange={handleChange}
        />
      </Flex>
    </SelectionViewWrapper>
  );
};

export default SubjectSelection;
